var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-relative w-100",
      style: { zIndex: _vm.isFocus ? 1000 : 1 }
    },
    [
      _c("b-form-input", {
        ref: "input_ref",
        attrs: {
          disabled: _vm.isDisabled,
          state: _vm.state,
          value: _vm.query || _vm.displayText,
          placeholder: _vm.placeholderText,
          autocomplete: "off"
        },
        on: {
          input: _vm.onSearchInput,
          focus: _vm.onFocusIn,
          blur: _vm.onFocusOut,
          click: function($event) {
            _vm.isFocus = true
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "select-input-body-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "custom-btn-select",
            attrs: { type: "button", disabled: _vm.isDisabled },
            on: {
              mousedown: function($event) {
                $event.preventDefault()
                return _vm.onClick.apply(null, arguments)
              }
            }
          },
          [
            _vm.selectedItems.length > 0 && !_vm.isFocus
              ? _c("v-icon", { attrs: { name: "buttons/cross", size: 11 } })
              : _vm.isFocus
              ? _c("v-icon", {
                  attrs: { name: "buttons/collapse_chevrons_down", size: 10 }
                })
              : _c("v-icon", {
                  attrs: { name: "buttons/collapse_chevrons_right", size: 10 }
                })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isFocus
        ? _c(
            "div",
            {
              staticClass: "custom-dropdown-select",
              class: { "drop-up": _vm.dropUp }
            },
            [
              _c(
                "div",
                { staticClass: "custom-dropdown-list-scroll" },
                _vm._l(_vm.filteredItems, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "custom-dropdown-select-item",
                      on: {
                        mousedown: function($event) {
                          $event.preventDefault()
                          return _vm.checkItem(item)
                        }
                      }
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "text-small m-0",
                          staticStyle: { "pointer-events": "none" },
                          attrs: { checked: _vm.isSelected(item.id) }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(item.name) + "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.filteredItems.length > 0 && _vm.canCreateCatalog
                ? _c(
                    "div",
                    {
                      staticClass:
                        "custom-dropdown-select-footer p-1 border-top"
                    },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "custom-btn-primary mt-0",
                          attrs: { disabled: _vm.isDisabled },
                          on: {
                            mousedown: function($event) {
                              $event.preventDefault()
                              return _vm.showModalCatalog.apply(null, arguments)
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            attrs: { name: "buttons/plus", size: 12 }
                          }),
                          _vm._v(
                            "\n        Добавить " +
                              _vm._s(_vm.catalogName) +
                              "\n      "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filteredItems.length === 0 && _vm.query
                ? _c(
                    "div",
                    { staticClass: "empty-state-container p-2" },
                    [
                      _c("v-icon", {
                        attrs: { name: "navbar/empty_table", size: 45 }
                      }),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v("Ничего не найдено")
                      ]),
                      _vm._v(" "),
                      _vm.canCreateCatalog
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "custom-btn-primary mt-2",
                              attrs: { disabled: _vm.isDisabled },
                              on: {
                                mousedown: function($event) {
                                  $event.preventDefault()
                                  return _vm.showModalCatalog.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", {
                                attrs: { name: "buttons/plus", size: 12 }
                              }),
                              _vm._v(
                                "\n        Добавить " +
                                  _vm._s(_vm.catalogName) +
                                  "\n      "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abcc2fde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abcc2fde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/CatalogMultiSelect.vue
// module id = null
// module chunks = 